import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { useListContext, useQuery, Link } from 'react-admin';

import useSupplyStyles from '../controls/SupplyStyles';

const STATUSES = [
    { id: '', name: 'All' },
    { id: 'OPEN', name: 'Open' },
    { id: 'FINALIZED', name: 'Finalized' },
    { id: 'CANCELLED', name: 'Cancelled' },
];

const ORIGIN_TYPES = [
    { id: '', name: 'All' },
    { id: 'VENDOR', name: 'Vendor' },
    { id: 'SITE', name: 'Site' },
];

/** Left-hand search card on the supply shipments screen. */
const ShipmentSearchAside = () => {
    const classes = useSupplyStyles();
    const { filterValues, setFilters } = useListContext();

    const [form, setForm] = useState({
        status: filterValues.status || 'FINALIZED',
        manifest_no: filterValues.manifest_no || '',
        origin_type: filterValues.origin_type || '',
        vendor_id: filterValues.vendor_id || '',
        origin_site: filterValues.origin_site || '',
        po_no: filterValues.po_no || '',
        ref_no: filterValues.ref_no || '',
        supply_type_id: filterValues.supply_type_id || '',
        lot_no: filterValues.lot_no || '',
        receipt_date_from: filterValues.receipt_date_from || '',
        receipt_date_to: filterValues.receipt_date_to || '',
    });

    const { data: vendors } = useQuery({
        type: 'getList',
        resource: 'supplyvendors',
        payload: {
            filter: { status: 1 },
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 200 },
        },
    });

    const { data: types } = useQuery({
        type: 'getList',
        resource: 'supplytypes',
        payload: {
            filter: { status: 1 },
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 500 },
        },
    });

    const set = (key, value) => setForm(prev => Object.assign({}, prev, { [key]: value }));

    const handleSearch = () => {
        const next = {};
        Object.keys(form).forEach(key => {
            if (form[key] !== '' && form[key] !== null && form[key] !== undefined) {
                next[key] = form[key];
            }
        });
        setFilters(next, {});
    };

    return (
        <Card className={classes.asideCard}>
            <CardContent>
                <Typography className={classes.asideTitle}>Search</Typography>

                <TextField
                    select fullWidth margin="dense" label="Status"
                    value={form.status} onChange={e => set('status', e.target.value)}
                >
                    {STATUSES.map(s => <MenuItem key={s.id || 'all'} value={s.id}>{s.name}</MenuItem>)}
                </TextField>

                <TextField
                    fullWidth margin="dense" label="Manifest #"
                    value={form.manifest_no} onChange={e => set('manifest_no', e.target.value)}
                />

                <TextField
                    select fullWidth margin="dense" label="Origin Type"
                    value={form.origin_type} onChange={e => set('origin_type', e.target.value)}
                >
                    {ORIGIN_TYPES.map(s => <MenuItem key={s.id || 'all'} value={s.id}>{s.name}</MenuItem>)}
                </TextField>

                <TextField
                    select fullWidth margin="dense" label="Origin Vendor"
                    value={form.vendor_id} onChange={e => set('vendor_id', e.target.value)}
                >
                    <MenuItem value="">All</MenuItem>
                    {(vendors || []).map(v => <MenuItem key={v.id} value={v.id}>{v.name}</MenuItem>)}
                </TextField>

                <TextField
                    fullWidth margin="dense" label="Origin Site"
                    value={form.origin_site} onChange={e => set('origin_site', e.target.value)}
                />

                <TextField
                    fullWidth margin="dense" label="PO #"
                    value={form.po_no} onChange={e => set('po_no', e.target.value)}
                />

                <TextField
                    fullWidth margin="dense" label="Ref #"
                    value={form.ref_no} onChange={e => set('ref_no', e.target.value)}
                />

                <TextField
                    select fullWidth margin="dense" label="Supply Type"
                    value={form.supply_type_id} onChange={e => set('supply_type_id', e.target.value)}
                >
                    <MenuItem value="">All</MenuItem>
                    {(types || []).map(t => <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>)}
                </TextField>

                <TextField
                    fullWidth margin="dense" label="Lot #"
                    value={form.lot_no} onChange={e => set('lot_no', e.target.value)}
                />

                <Typography className={classes.asideLabel}>Receipt Date</Typography>
                <TextField
                    fullWidth margin="dense" type="date" label="From"
                    InputLabelProps={{ shrink: true }}
                    value={form.receipt_date_from}
                    onChange={e => set('receipt_date_from', e.target.value)}
                />
                <TextField
                    fullWidth margin="dense" type="date" label="To"
                    InputLabelProps={{ shrink: true }}
                    value={form.receipt_date_to}
                    onChange={e => set('receipt_date_to', e.target.value)}
                />

                <Button
                    variant="contained" color="primary" size="small"
                    onClick={handleSearch} className={classes.searchButton}
                >
                    Search
                </Button>

                <Typography className={classes.asideTitle} style={{ marginTop: '1.2em' }}>
                    Actions
                </Typography>
                <Link to="/supplyshipments/create" className={classes.actionLink}>
                    New Supply Shipment
                </Link>
            </CardContent>
        </Card>
    );
};

export default ShipmentSearchAside;
